import React, {createRef, useEffect, useRef, useState} from 'react';
import LoadingShimmerCustom from '../../shared/LoadingShimmerCustom';
import styles from '../createNewLearningPath/CreateNewLP.module.scss';
import { PUBLISHING_STATUS } from '../ConstantsUtil';
import { getHigheshScheduledTimestamp } from '../learningPathUtils';
import { useSelector } from 'react-redux';
import { IS_JAPAN, IS_THAILAND } from '../../../utils/datePicker';
const ReviewAndPublish = ({
  isTitle = false,
  isDescription = false,
  isThumbnail = false,
  isSpeaker = false,
  //isAllCoursesLive = false,
  handleGoToDescriptionPage,
  handleGoToSequencingPage,
  addedCourseList = [],
  data = null,
  openArchivedModal,
  isLoadingApi,
  publishingStatus,
  publishDate,
  publishTime,
  publishDateInputError,
  publishTimeInputError,
  lpSchedulePublishError,
  handlePublishStatus,
  handlePublishDateChange,
  handlePublishTimeChange
}) => {

  const LPState = data?.state ? data?.state : '';
  const invalidCourse = addedCourseList.filter((ele) => ele.courseState !== 'Live' && ele.courseState !== 'Scheduled');
  const [openArchived, setOpenArchived] = useState(false);
  let DATE_FORMAT = useSelector(
    (state) => state?.uiState?.remoteConfig?.date_format || 'MM/DD/YYYY'
  );
  DATE_FORMAT = IS_THAILAND ? 'DD/MM/YYYY' : DATE_FORMAT;
  const minimumScheduledTimestamp = getHigheshScheduledTimestamp(addedCourseList, DATE_FORMAT)
  return (
    <div
      className={[
        styles.inner_wrapper,
        styles.category_wrapper,
        styles.review_publish_wrapper,
        '',
      ].join(' ')}
    >
      <div className={styles.row_wrapper}>
        <div className={[styles.info_container, styles.category_inner_wrapper].join(' ')}>
          <div
            className={[styles.inr_wrapper, styles.margin_pad_x, 'col-md-12 col-lg-12'].join(' ')}
          >
            <div className={styles.title_wrapper}>
              <div className={styles.title}>Mandatory fields</div>
              <div className={styles.txt}>
                If all the mandatory fields are not fixed, you will not be able to publish the
                Learning Path. Please fix these fields before publishing.
              </div>
            </div>

            <div className={[styles.review_publish_lp].join(' ')}>
              {/* <div className={styles.title}>Learning Path Description</div> */}
              <div className={styles.section_title}>Translation</div>
              <div className={styles.card_wrapper}>
                {(isLoadingApi) ? (
                  <div
                    className={[
                      styles.card_gutters,
                      isTitle ? styles.success_review_publish : styles.error_review_publish,
                      'col-md-12 col-lg-4',
                    ].join(' ')}
                  >
                    <LoadingShimmerCustom className={[styles.card_shimmer].join(' ')} />
                  </div>
                ) : (
                  <div
                    className={[
                      styles.card_gutters,
                      isTitle ? styles.success_review_publish : styles.error_review_publish,
                      'col-md-12 col-lg-4',
                    ].join(' ')}
                  >
                    <div className={styles.card}>
                      <div className={styles.status_icon} />
                      <div className={styles.details_wrapper}>
                        <div className={styles.title}>
                          {isTitle ? 'Course Translation Added' : 'Recommended: Add [Language] Translation'}
                        </div>
                        <div className={styles.sub_title}>
                          {isTitle
                            ? 
                            ''
                            // 'Vietnamese Title on Learning Path Description page is filled.'
                            : 
                            // 'Vietnamese Title on Learning Path Description page is missing.'
                            'The Course “Course Name Here” has [Language] as a language but the learning path does not. It is recommended to ‘Go to Page’ to add translation.'
                            }
                        </div>
                      </div>
                      {isTitle ? null : (
                        <div
                          className={styles.go_page}
                          onClick={() => {
                            handleGoToDescriptionPage();
                          }}
                        >
                          Go To Page
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.review_publish_lp}>
              <div className={styles.section_title}>Course Sequencing</div>
              <div className={styles.card_wrapper}>
                {isLoadingApi ? (
                  <div
                    className={[
                      styles.card_gutters,
                      ((invalidCourse?.length === 0 && (LPState == 'Draft' || LPState == '')) ||
                        LPState == 'Live' ||
                        LPState == 'Offline') &&
                      addedCourseList.length >= 2
                        ? styles.success_review_publish
                        : styles.error_review_publish,
                      'col-md-12 col-lg-12',
                    ].join(' ')}
                  >
                    <LoadingShimmerCustom className={[styles.card_shimmer].join(' ')} />
                  </div>
                ) : (
                  <div
                    className={[
                      styles.card_gutters,
                      ((invalidCourse?.length === 0 && (LPState == 'Draft' || LPState == '')) ||
                        LPState == 'Live' ||
                        LPState == 'Offline' || LPState == 'Scheduled') &&
                      addedCourseList.length >= 2
                        ? styles.success_review_publish
                        : styles.error_review_publish,
                      // 'col-md-12 col-lg-12',
                      `col-md-12 col-lg-${((invalidCourse?.length === 0 && (LPState == 'Draft' || LPState == '')) ||
                      LPState == 'Live' ||
                      LPState == 'Offline' || LPState == 'Scheduled') &&
                      addedCourseList.length >= 2
                    ? 3 : 12}`,
                    ].join(' ')}
                  >
                    <div className={styles.card}>
                      <div className={styles.status_icon} />
                      <div className={styles.details_wrapper}>
                        <div className={styles.title}>
                          {' '}
                          {((invalidCourse?.length === 0 &&
                            (LPState == 'Draft' || LPState == '')) ||
                            LPState == 'Live' ||
                            LPState == 'Offline' || LPState == 'Scheduled') &&
                          addedCourseList.length >= 2
                            ? 'All courses are Live/Scheduled'
                            : 'All Courses are not Live/Scheduled'}
                        </div>
                        <div className={styles.sub_title}>
                          {((invalidCourse?.length === 0 &&
                            (LPState == 'Draft' || LPState == '')) ||
                            LPState == 'Live' ||
                            LPState == 'Offline' || LPState == 'Scheduled') &&
                          addedCourseList.length >= 2
                            ? 
                            ''
                            // 'This Learning Path has more than 2 courses. All courses in this Learning Path are Live. If you change the status of these courses to offline while editing the course, then they shall appear offline to all the User Groups. The ABO will not receive Learning Path certificate if any particular course is offline if they haven’t started or their course is In-Progress.'
                            : 'Add a minimum of 2 courses in the Learning Path. Some courses in this Learning Path are not Live/Scheduled. Change the status of these courses by editing the course or remove them from this Learning Path. You can only publish this Learning Path when all the courses are Live/Scheduled.'}
                        </div>
                      </div>
                      {((invalidCourse?.length === 0 && (LPState == 'Draft' || LPState == '')) ||
                        LPState == 'Live' ||
                        LPState == 'Offline' || LPState == 'Scheduled') &&
                      addedCourseList.length >= 2 ? null : (
                        <div
                          className={styles.go_page}
                          onClick={() => {
                            handleGoToSequencingPage();
                          }}
                        >
                          Go To Page
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.review_publish_lp}>
              <div className={styles.section_title}>Visibility</div>
              <div className={styles.visibility_desc}>Choose when to make this Learning Path visible</div>
              <div className={styles.publish_radio_button_wrapper}>
                <div className={styles.publish_radio_button_inner_wrapper}>
                  <input
                    type='radio'
                    name='publishMode'
                    value={PUBLISHING_STATUS.NOW}
                    checked={publishingStatus === PUBLISHING_STATUS.NOW}
                    onChange={handlePublishStatus}
                    className={styles.publish_radio_button}
                  />
                  <label>
                    Publish Now
                  </label>
                </div>
                <div className={styles.publish_radio_button_inner_wrapper}>
                  <input
                    type="radio"
                    name="publishMode"
                    value={PUBLISHING_STATUS.SCHEDULED}
                    checked={publishingStatus === PUBLISHING_STATUS.SCHEDULED}
                    onChange={handlePublishStatus}
                    className={styles.publish_radio_button}
                  />
                  <label>
                    Scheduled Publishing
                  </label>
                </div>
              </div>
              {publishingStatus === PUBLISHING_STATUS.SCHEDULED && <div className={styles.publish_input_wrapper}>
                <div className={styles.publish_date_wrapper}>
                  <label htmlFor='publishDate'>Publish Date</label>
                  <input
                    id='publishDate'
                    type={'text'}
                    placeholder={DATE_FORMAT}
                    className={`${styles.publish_date_input} ${publishDateInputError ? styles.error : ''}`}
                    defaultValue={''}
                    value={publishDate}
                    name="publishDate"
                    onChange={handlePublishDateChange}
                    disabled={LPState === 'Live'}
                    maxLength={IS_JAPAN ? 11 : 10}
                  />
                  {publishDateInputError ? <div className={styles.error_icon_red}></div> : null}
                  {publishDateInputError && <div className={styles.error_message}>{publishDateInputError}</div>}
                </div>
                <div className={styles.publish_date_wrapper}>
                  <label htmlFor='publishTime'>Publish Time</label>
                  <input
                    id='publishTime'
                    type={'text'}
                    placeholder={'00:00'}
                    className={`${styles.publish_date_input} ${publishTimeInputError ? styles.error : ''}`}
                    defaultValue={''}
                    value={publishTime}
                    name="publishTime"
                    onChange={handlePublishTimeChange}
                    disabled={LPState === 'Live'}
                    maxLength={5}
                  />
                  {publishTimeInputError ? <div className={styles.error_icon_red}></div> : null}
                  {publishTimeInputError && <div className={styles.error_message}>{publishTimeInputError}</div>}
                </div>
            </div>}
            {publishingStatus === PUBLISHING_STATUS.SCHEDULED && <p className={styles.scheduled_lp_info}>A Learning Path may be scheduled up to 30 days in advance.</p>}
            </div>

            {publishingStatus && lpSchedulePublishError && <div className={[styles.review_publish_lp].join(' ')}>
              <div className={styles.card_wrapper}>
                <div
                  className={[
                    styles.card_gutters,styles.error_review_publish,
                    `col-md-12 col-lg-12`,
                  ].join(' ')}
                >
                  <div className={styles.card}>
                    <div className={styles.status_icon} />
                    <div className={styles.details_wrapper}>
                      <div className={styles.title}>
                        {' '}
                        {'Publish date needs revision'}
                      </div>
                      <div className={styles.sub_title}>
                        {`This Learning Path cannot be scheduled because its publish date is before the publish date of the Course. The minimum allowed publish date is ${minimumScheduledTimestamp || ''}.`}
                      </div>
                    </div>
                      <div
                        className={styles.go_page}
                        onClick={() => {
                          handleGoToSequencingPage();
                        }}
                      >
                        Go To Page
                      </div>
                  </div>
                </div>
              </div>
            </div>}

            {LPState == 'Live' || LPState == 'Offline' ? (
              <div
                className={[styles.review_publish_lp, styles.decommission_section, ''].join(' ')}
              >
                <div
                  className={styles.title_wrapper}
                  onClick={() => setOpenArchived(!openArchived)}
                >
                  <div className={styles.danger_icon}></div>
                  <div className={styles.title}>Decommission Learning Path</div>
                  <div
                    className={[
                      styles.arrow,
                      openArchived ? styles.up_arrow : styles.down_arrow,
                    ].join(' ')}
                  ></div>
                </div>
                <div className={[styles.card_wrapper, openArchived ? '' : 'hide'].join(' ')}>
                  <div className={[styles.card_gutters, 'col-md-12 col-lg-12'].join(' ')}>
                    <div className={styles.description}>
                      This will permanently remove a Learning Path from the Academy App. Users who
                      have taken the Learning Path will still see the archived version in their
                      Completed Learning Path section but may not re-take it. No user can start the
                      Learning Path once archived. This action cannot be undone.{' '}
                    </div>
                    <div
                      className={[styles.btn, styles.archive].join(' ')}
                      onClick={() => openArchivedModal(true)}
                    >
                      <div className={styles.delete_icon}></div>
                      <div className={styles.text}>Archive This Learning Path</div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

ReviewAndPublish.propTypes = {};

export default ReviewAndPublish;
